export interface IQualificationBasisDef {
    typeCode: string;
    typeName: string;
    yearFreeMax: number;
    yearIntervals: string[];
}

export interface IBasisParamterDef {
    category: string;
    dateOfBirth: Date;
    maxToYear: number;
    orientation?: string;
}

export const BASIS_CATEGORY_DEF_NAMES = {
    COMMON: 'COMMON', // Bilaga 4.
    OTHER: 'OTHER', // Vissa ämnen.
    SUBJECT_AREA: 'SUBJECT_AREA',
    VOCATIONAL: 'VOCATIONAL', // Yrkesämnen.
};
